import { routes, storageKeys } from '../constants';
import axios, { isAxiosError } from 'axios';
import { EUserProvider } from 'types';
import { clearStorage } from 'utils';
import { resolveBackendBaseUrl } from './backendBaseUrl';

const isDevelopment = process.env.NODE_ENV === 'development';

axios.defaults.baseURL = resolveBackendBaseUrl();
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.params = isDevelopment
  ? undefined
  : { provider: EUserProvider.MALE_APPLICATION };

// request interceptor
axios.interceptors.request.use((config) => {
  const accessToken: string | null = localStorage.getItem(
    storageKeys.ACCESS_TOKEN,
  );
  if (accessToken != null) {
    const accessHeader = `Bearer ${accessToken}`;
    if (config.headers != null) {
      const existingAuthorization =
        config.headers.Authorization ||
        (typeof config.headers.get === 'function'
          ? config.headers.get('Authorization')
          : undefined);
      const fromDefaults = axios.defaults.headers.common?.Authorization;
      if (!existingAuthorization || existingAuthorization === fromDefaults) {
        config.headers.Authorization = accessHeader;
      }
      config.headers['ngrok-skip-browser-warning'] = 'true';
    }
  }
  // config.withCredentials = !isDevelopment;
  return config;
});

const handleRefreshToken = async (refreshToken: string) => {
  // gets new token
  if (refreshToken) {
    const token = await axios
      .post(`accounts/refresh-token`, {
        refreshToken,
      })
      .then(function (response) {
        return response.data.accessToken;
      });
    localStorage.setItem(storageKeys.ACCESS_TOKEN, token);
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  } else throw new Error('');
};

// response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // handle response un-authen error
    if (!error?.response?.status) {
      console.error('[axios] network error', error);
      // リクエスト種別を問わない外部遷移は、無関係な起動時通信の遮断でも利用者の操作を破棄するため行わない。
    }

    if (error.response?.status === 401) {
      // gets new token
      const refreshToken = localStorage.getItem(storageKeys.REFRESH_TOKEN);
      if (refreshToken) {
        try {
          await handleRefreshToken(refreshToken);
          window.location.reload();
          return;
        } catch (error) {
          console.error('🚀 ~ error:', error);
        }
      }
      clearStorage();
      window.location.href = routes.LOGIN;
      return new Promise(() => {});
    }

    if (isAxiosError(error)) {
      error.message = error.response?.data?.message || error.message;
      error.status = error.response?.status;
    }
    return Promise.reject(error);
  },
);
